import React from 'react';
import HeroQuoteSection from '../sections/heroQuoteSection';
import TextWithImage from '../sections/textWithImage';
import HeadingWithIcons from '../sections/headingWithIcons';
import IconsWithHeadingText from '../sections/iconsWithHeadingText';
import FAQ from '../sections/faq';
import HeadingWithGrid from '../sections/headingWithGrid';
import IconsWithText from '../sections/iconsWithText';
import { Redirect } from "react-router-dom";

function Service({match}) {
    var content;
    //add a class home
    const body = document.body;
    const serviceId = match.params.id;
    
    body.classList = 'template-service service-' + serviceId;    
    const serviceHandle = (require('../jsons/quote-service-options').default)[serviceId];
    if(serviceHandle){
      content = (require('../jsons/' + serviceId + '.js')).default;
    }

    return (
      <div>
        {serviceHandle
          ? 
          <div className="innerWrapper">
            {content.heroQuoteSection &&
              <HeroQuoteSection data={content.heroQuoteSection} serviceCat={serviceId} />        
            }        
            <div className="sections whiteBg">
              {content.textWithImage &&
                <TextWithImage data={content.textWithImage} />
              }       
              {content.iconsWithHeadingText &&
                <IconsWithHeadingText data={content.iconsWithHeadingText} />
              }
              {content.headingWithIcons &&
                <HeadingWithIcons data={content.headingWithIcons} />
              } 
              {content.headingWithGrid &&
                <HeadingWithGrid data={content.headingWithGrid} />
              }
              {content.iconsWithText &&
                <IconsWithText data={content.iconsWithText} />
              }
              {content.faq &&
                <FAQ data={content.faq} />
              }
            </div>
          </div>
          :
          <Redirect to={{ pathname: "/" }} />        
        }
      </div>
    )
};

export default Service; 